export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Navbar.vue?vue&type=template&id=50bd3bb6"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/navbar/Navbar.vue?vue&type=template&id=50bd3bb6
// module id = A4kC
// module chunks = 41